module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-3-fd16dc7605d25873d0cdd2d118b1c78f.svg";